export default {
	state: {
		showReturn: false
	},
	mutations: {
		CHANGEISRETURN(state) {
			state.showReturn = !state.showReturn
		}
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/isReturn.js